if (!customElements.get('product-form')) {
  customElements.define('product-form', class ProductForm extends HTMLElement {
    constructor() {
      super();

      this.form = this.querySelector('form');
      this.form.querySelector('[name=id]').disabled = false;
      this.form.addEventListener('submit', this.onSubmitHandler.bind(this));
      this.cartNotification = document.querySelector('cart-notification');
    }

    onSubmitHandler(evt) {
      evt.preventDefault();
      const submitButton = this.querySelector('[type="submit"]');
      const submitButtonSpan = submitButton.querySelector('span:not(.loading-overlay__spinner)');

      const stickyTarget = this.querySelector('.sticky-target');
      const stickyTargetSpan = stickyTarget.querySelector('span:not(.loading-overlay__spinner)');

      if (submitButton.classList.contains('loading')) return;

      this.handleErrorMessage();
      
      // Check if cartNotification exists before using it
      if (this.cartNotification) {
        this.cartNotification.setActiveElement(document.activeElement);
      }

      submitButton.setAttribute('aria-disabled', true);
      submitButton.classList.add('loading');
      this.querySelector('.loading-overlay__spinner').classList.remove('hidden');
      submitButtonSpan.classList.add('hidden');

      

      stickyTarget.setAttribute('aria-disabled', true);
      stickyTarget.classList.add('loading');
      stickyTarget.querySelector('.loading-overlay__spinner').classList.remove('hidden');
      stickyTargetSpan.classList.add('hidden');

      const config = fetchConfig('javascript');
      config.headers['X-Requested-With'] = 'XMLHttpRequest';
      delete config.headers['Content-Type'];

      const formData = new FormData(this.form);
      
      // Check if cartNotification exists before using it
      if (this.cartNotification) {
        formData.append('sections', this.cartNotification.getSectionsToRender().map((section) => section.id));
      }
      formData.append('sections_url', window.location.pathname);
      formData.append('quantity', Number(this.querySelector('[name="quantity"]')?.value || 1));
      config.body = formData;

      fetch(`${routes.cart_add_url}`, config)
        .then((response) => response.json())
        .then((response) => {
          if (response.status) {
            this.handleErrorMessage(response.description);
            return;
          }

          // Check if cartNotification exists before using it
          if (this.cartNotification) {
            this.cartNotification.productJustAddedToCart(response);
          }
        })
        .catch((e) => {
          console.error(e);
        })
        .finally(() => {
          submitButton.classList.remove('loading');
          submitButton.removeAttribute('aria-disabled');
          this.querySelector('.loading-overlay__spinner').classList.add('hidden');
          submitButtonSpan.classList.remove('hidden');

          stickyTarget.classList.remove('loading');
          stickyTarget.removeAttribute('aria-disabled');
          stickyTarget.querySelector('.loading-overlay__spinner').classList.add('hidden');
          stickyTargetSpan.classList.remove('hidden');
        });
    }

    handleErrorMessage(errorMessage = false) {
      if (this.classList.contains('product-form--gift-card') && errorMessage.email) {
        errorMessage = errorMessage.email;
      }

      this.errorMessageWrapper = this.errorMessageWrapper || this.querySelector('.product-form__error-message-wrapper');
      this.errorMessage = this.errorMessage || this.errorMessageWrapper.querySelector('.product-form__error-message');

      this.errorMessageWrapper.toggleAttribute('hidden', !errorMessage);

      if (errorMessage) {
        this.errorMessage.textContent = errorMessage;
      }
    }
  });
}
